import { View } from "@tarojs/components";
import classNames from "classnames";
import * as _ from "lodash";
import * as React from "react";
import { Children, cloneElement, isValidElement, useMemo, } from "react";
import { prefixClassname } from "../styles";
import { isElementOf } from "../utils/validate";
import Avatar from "./avatar";
const useAvatars = (children, shape, limit) => {
    return useMemo(() => {
        const avatars = Children.toArray(children)
            .filter((child) => isValidElement(child) && isElementOf(child, Avatar));
        const avatarsSize = _.size(avatars);
        const luckyAvatars = [];
        const length = Math.min(avatarsSize, limit);
        for (let index = 0; index < length; index++) {
            const child = _.get(avatars, index);
            const element = child;
            const { key, props } = element;
            const { style, children, ...restProps } = props;
            luckyAvatars.push(cloneElement(element, {
                key: key ?? index,
                shape,
                style: {
                    ...style,
                    zIndex: index,
                },
                ...restProps,
            }, children));
        }
        return [luckyAvatars, avatarsSize];
    }, [children, limit, shape]);
};
export default function AvatarGroup(props) {
    const { className, shape = "circle", limit = Number.MAX_VALUE, spacing = "small", total, children, } = props;
    const [avatars, avatarsSize] = useAvatars(children, shape, limit);
    return (React.createElement(View, { className: classNames(prefixClassname("avatar-group"), {
            [prefixClassname("avatar-group--spacing-mini")]: spacing === "mini",
            [prefixClassname("avatar-group--spacing-small")]: spacing === "small",
            [prefixClassname("avatar-group--spacing-medium")]: spacing === "medium",
            [prefixClassname("avatar-group--spacing-large")]: spacing === "large",
        }, className) },
        avatars,
        avatarsSize >= limit && (React.createElement(Avatar, { shape: shape, style: { zIndex: avatarsSize } },
            "+",
            total ? total - limit : avatarsSize - limit))));
}
